class BESSAppBase {

    constructor() {

    }

    getClassName() {
        return this.constructor.name;
    }

    log(msg, object) {
        if (BESSApp.instance != null && BESSApp.instance.dev) {
            console.log('[' + this.getClassName() + '] ' + msg);
            if (object !== undefined) {
                console.log(object);
            }
        }
    }

    showViewIf(view, condition) {
        if (condition) {
            view.show();
        } else {
            view.hide();
        }
    }

    subscribeToEvents(eventName, eventHandleFunction) {
        $(document).on(eventName, function (_, event) {
            eventHandleFunction.bind(this)(event);
        }.bind(this));

        if (eventName in BESSAppBase.lastEventLog) {
            let lastEvent = BESSAppBase.lastEventLog[eventName];
            eventHandleFunction.bind(this)(lastEvent);
        }
    }

    getLastEventFor(eventName) {
        return BESSAppBase.lastEventLog[eventName];
    }

    static lastEventLog = {};

    fireEvent(event, silent = false) {
        if (!silent) {
            this.log('fireEvent', event);
        }
        BESSAppBase.lastEventLog[event.name] = event;
        $(document).trigger(event.name, [event,]);
    }

    informUser(title, message) {
        bootbox.alert({
            title: title,
            message: message,
        });
    }

    askUserToConfirmSeriousOperation(title, message, confirmFn, yesActionName = 'Yes', noActionName = 'No', dismissFn = null) {
        this.askUserToConfirm(title, message, confirmFn, yesActionName, noActionName, dismissFn, 'btn-danger');
    }

    askUserToConfirm(title, message, confirmFn, yesActionName, noActionName, dismissFn = null, yesClass = 'btn-primary') {
        yesActionName = yesActionName === undefined ? "Yes" : yesActionName;
        noActionName = noActionName === undefined ? "No" : noActionName;
        bootbox.confirm({
            title: title,
            message: message,
            backdrop: true,
            closeButton: false,
            swapButtonOrder: true,
            buttons: {
                confirm: {
                    label: yesActionName,
                    className: yesClass
                },
                cancel: {
                    label: noActionName,
                    className: 'btn-secondary'
                }
            },
            callback: function (result) {
                if (result) {
                    confirmFn();
                } else if (dismissFn !== null) {
                    dismissFn();
                }
            }
        });
    }

    askForTextInput(title, message, value, callbackFn) {
        bootbox.prompt({
            title: title,
            message: message,
            value: value,
            callback: function (result) {
                if (result != null) {
                    callbackFn.bind(this)(result);
                }
            }.bind(this)
        });
    }

    askForDescriptiveTextInput(title, message, value, callbackFn) {
        bootbox.prompt({
            title: title,
            message: message,
            inputType: 'textarea',
            value: value,
            callback: function (result) {
                if (result != null) {
                    callbackFn.bind(this)(result);
                }
            }.bind(this)
        });
    }

    showDoingWork(title, message) {
        this.doingWork = new BESSAppDoingWorkBlockingModal(title, message);
    }

    hideDoingWork() {
        this.doingWork.close();
    }

    forEach(collection, handler) {
        if (collection == null) return;
        _.forEach(collection, handler.bind(this));
    }

    find(collection, fn) {
        if (collection == null) return null;
        return _.find(collection, fn.bind(this));
    }

    doDelayed(fn, delay) {
        setTimeout(fn.bind(this), delay);
    }

    isDarkTheme() {
        return $('body').hasClass('dark-theme');
    }

    onSelected(node, handler) {
        node.bindClickEvent(this, handler);
    }
}